import React from 'react';
import { ArrowLeft } from 'phosphor-react';
import { PageNavBar } from '../PageNavBar';
import { Button } from '../Button';
import { OrderBadge } from './OrderBadge';

interface ThreadHeaderProps {
  displayName: string;
  onBack?: () => void;
  onViewOrders?: () => void;
  onOrderBadgeClick?: (orderId: number) => void;
  orderId?: number;
  orderStatus?: 'pending' | 'ready';
  isMasterDetail?: boolean;
}

export const ThreadHeader: React.FC<ThreadHeaderProps> = ({
  displayName,
  onBack,
  onViewOrders,
  onOrderBadgeClick,
  orderId,
  orderStatus,
  isMasterDetail = false
}) => {
  // Only show on mobile/full-page view (not in master-detail)
  if (isMasterDetail) {
    return null;
  }

  return (
    <PageNavBar
      left={
        onBack ? (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="hover:bg-black/5 shrink-0"
            aria-label="Volver"
          >
            <ArrowLeft size={20} weight="bold" />
          </Button>
        ) : null
      }
      center={
        <p className="font-sans font-semibold text-base text-text tracking-[-0.16px] truncate max-w-[250px]">
          {displayName}
        </p>
      }
      right={
        <div className="flex items-center gap-2">
          {orderId && (
            <OrderBadge
              orderId={orderId}
              status={orderStatus}
              onClick={(e) => {
                e.stopPropagation();
                if (onOrderBadgeClick) {
                  onOrderBadgeClick(orderId);
                }
              }}
              size="md"
            />
          )}
          {onViewOrders ? (
            <Button
              variant="ghost"
              onClick={onViewOrders}
              className="text-sm whitespace-nowrap"
            >
              Pedidos
            </Button>
          ) : null}
        </div>
      }
    />
  );
};

export default ThreadHeader;
